export enum DIGITOOL_TYPE {
  PLAYING_CARDS = 'playingCards',
  MONEY = 'money',
  TABLE_SQUARE = 'tableSquare',
  NUMBER_CARDS = 'numberCards',
  FIXED_NUMBER_CARDS = 'fixedNumberCards',
  CHECKERS = 'checkers',
  CALCULATOR = 'calculator',
}
